import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface EnumSelectProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label: string;
  options: readonly string[];
  error?: string;
  placeholder?: string;
}

export function EnumSelect<T extends FieldValues>({
  control,
  name,
  label,
  options,
  error,
  placeholder = 'Select an option',
}: EnumSelectProps<T>) {
  return (
    <div className="space-y-3">
      <Label className="text-base font-semibold text-brand-dark">{label}</Label>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Select value={field.value || ''} onValueChange={field.onChange}>
            <SelectTrigger className={`rounded-lg border-slate-200 bg-white text-brand-dark focus:border-brand-orange transition-colors duration-200 ${error ? 'border-red-500 focus:border-red-500 ' : ''}`}>
              <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent className="rounded-lg bg-white text-brand-dark border-slate-200 shadow-sm">
              {options.map((option) => (
                <SelectItem key={option} value={option} className="text-brand-dark hover:bg-slate-100 focus:bg-slate-100">
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      />
      {error && <p className="text-sm text-red-600 mt-2 font-medium">{error}</p>}
    </div>
  );
}